import PropTypes from 'prop-types'
import React, { useContext } from 'react'

import CircularProgress from '@material-ui/core/CircularProgress'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'

import { ThemeContext } from '../../contexts'
import { useStyles } from '../../hooks/useStyles/useStyles'

const styles = (theme) => ({
  root: {
    bottom: theme.spacing(6),
    left: 0,
    padding: theme.spacing(2),
    position: 'absolute',
    right: 0,
    top: 0,
  },
  loading: {
    color: '#000',
  },
  title: {
    color: '#000',
    flexGrow: 1,
  },
})

function LoadingScreen(props) {
  const { message = 'Carregando...' } = props

  const themeContext = useContext(ThemeContext)

  const classes = useStyles(styles, themeContext)

  return (
    <Grid
      alignItems="center"
      className={classes.root}
      container
      justify="center"
      direction="column"
      spacing={0}
    >
      <Grid item>
        <CircularProgress className={classes.loading} />
      </Grid>
      <Grid item>
        <Typography className={classes.title} variant="subtitle1">
          {message}
        </Typography>
      </Grid>
    </Grid>
  )
}

LoadingScreen.propTypes = {
  message: PropTypes.string,
}

export default React.memo(LoadingScreen)
